import { useEffect } from "react";
import { Box, Typography, CircularProgress } from "src/components";

const APP_STORE_URL = "https://apps.apple.com/us/app/panam-explorer/id6752216637";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.panamhighway.panamexplorer";
const FALLBACK_URL = "/"; // homepage fallback

const QrRedirect = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let target = FALLBACK_URL;

    if (/android/i.test(userAgent)) {
      target = PLAY_STORE_URL;
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      target = APP_STORE_URL;
    }

    const timer = setTimeout(() => {
      window.location.href = target;
    }, 1000); // keep small delay for loader

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box 
      display="flex" 
      flexDirection="column"
      alignItems="center" 
      justifyContent="center" 
      minHeight="100vh"
      gap={2}
    >
      <CircularProgress />
      <Typography variant="h6" color="text.secondary">
        Redirecting to the app store...
      </Typography>
    </Box>
  );
};

export default QrRedirect;
